export interface LowPaidLabelCtaState {
  monthlyLimit: number;
  monthlyLabelsRemaining: number;
  paidLabelsAvailable: number;
  isSpecialAccount?: boolean;
}

const LOW_PAID_LABEL_CTA_COOKIE_PREFIX = "menusano_low_paid_label_cta_dismissed";
const LOW_PAID_LABEL_CTA_DISMISSAL_SECONDS = 3 * 24 * 60 * 60;

export function getLowPaidLabelCtaCookieName(restaurantId?: number): string {
  return `${LOW_PAID_LABEL_CTA_COOKIE_PREFIX}_${restaurantId ?? "account"}`;
}

export function hasLowPaidLabelCtaDismissalCookie(
  restaurantId?: number,
  cookieHeader: string = typeof document === "undefined" ? "" : document.cookie,
): boolean {
  const cookieName = encodeURIComponent(getLowPaidLabelCtaCookieName(restaurantId));
  return cookieHeader.split(";").some((cookie) => cookie.trim().startsWith(`${cookieName}=`));
}

export function setLowPaidLabelCtaDismissalCookie(restaurantId?: number): void {
  if (typeof document === "undefined") {
    return;
  }

  const cookieName = encodeURIComponent(getLowPaidLabelCtaCookieName(restaurantId));
  const secure = typeof window !== "undefined" && window.location.protocol === "https:"
    ? "; Secure"
    : "";

  document.cookie = `${cookieName}=1; Max-Age=${LOW_PAID_LABEL_CTA_DISMISSAL_SECONDS}; Path=/; SameSite=Lax${secure}`;
}

export function getProjectedMonthlyLabelsRemaining(
  monthlyLabelsRemaining: number,
  labelsConsumed: number = 1,
): number {
  return Math.max(Number(monthlyLabelsRemaining) - Number(labelsConsumed), 0);
}

export function shouldShowLowPaidLabelCta(state: LowPaidLabelCtaState): boolean {
  const monthlyLimit = Number(state.monthlyLimit);
  if (
    state.isSpecialAccount
    || Number(state.paidLabelsAvailable) > 0
    || !Number.isFinite(monthlyLimit)
    || monthlyLimit <= 0
  ) {
    return false;
  }

  const projectedRemaining = getProjectedMonthlyLabelsRemaining(state.monthlyLabelsRemaining);
  return projectedRemaining / monthlyLimit <= 0.2;
}
